// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarAnaliseProjeto_homologacaoBotoes__+PrOg","motivoArquivamento":"ArquivarAnaliseProjeto_motivoArquivamento__sUdJz"};